module.exports = __webpack_public_path__ + "static/img/04ko.3748b61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/04ko.jpg
// module id = 5Mxy
// module chunks = 0